import { Box, Chip, Divider, Typography } from '@mui/material';

const estadoColors = {
  0: 'default',
  1: 'info',
  2: 'warning',
  3: 'error',
  4: 'success',
};

const Field = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
    <Typography variant="caption" sx={{ color: '#9aa5b4', textTransform: 'uppercase', letterSpacing: 1, fontSize: '0.7rem' }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ color: '#e2e8f0', fontWeight: 500 }}>
      {value ?? '—'}
    </Typography>
  </Box>
);

const TournamentInfo = ({ torneo }) => {
  if (!torneo) return null;

  const estado = torneo.tor_estado;
  const estadoLabel = torneo.tor_estado_detalle ?? 'Desconocido';
  const tipo = torneo.tor_tipo_detalle ?? '—';
  const sistema = torneo.tor_sistema_detalle ?? '—';
  const ritmo = torneo.tor_ritmo_detalle ?? '—';
  const rankeado = torneo.tor_rankeado === 'S' ? 'Sí' : torneo.tor_rankeado === 'N' ? 'No' : '—';
  const fechaInicio = torneo.fecha_inicio ?? '—';

  return (
    <Box>
      {/* Estado badge */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Chip
          label={estadoLabel}
          color={estadoColors[estado] ?? 'default'}
          variant="outlined"
          size="small"
          sx={{ fontWeight: 600, letterSpacing: 0.5, borderRadius: 0 }}
        />
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', mb: 3 }} />

      {/* Grid de campos */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 3,
        }}
      >
        <Field label="Organizador" value={torneo.tor_organizador} />
        <Field label="Lugar" value={torneo.tor_lugar} />
        <Field label="Árbitro" value={torneo.tor_arbitro} />
        <Field label="Tipo" value={tipo} />
        <Field label="Sistema" value={sistema} />
        <Field label="Ritmo de juego" value={ritmo} />
        <Field label="Rondas" value={torneo.tor_rondas} />
        <Field label="Rankeado" value={rankeado} />
        <Field label="Fecha de inicio" value={fechaInicio} />
      </Box>

      {torneo.tor_comentarios && (
        <>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', my: 3 }} />
          <Box>
            <Typography variant="caption" sx={{ color: '#9aa5b4', textTransform: 'uppercase', letterSpacing: 1, fontSize: '0.7rem' }}>
              Comentarios
            </Typography>
            <Typography variant="body2" sx={{ color: '#e2e8f0', mt: 0.5, lineHeight: 1.8 }}>
              {torneo.tor_comentarios}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default TournamentInfo;
